import { render, staticRenderFns } from "./service.vue?vue&type=template&id=aeddbe40&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=aeddbe40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeddbe40",
  null
  
)

export default component.exports